/* eslint-disable react/no-unknown-property */
/* eslint-disable no-constant-condition */
/* eslint-disable no-useless-escape */
/* eslint-disable no-param-reassign */
/* eslint-disable no-trailing-spaces */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Input, Row, Col, notification, Button, Checkbox, Space, Tree } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import * as utility from '../utils/utility';
import * as constants from '../utils/constants';
import { authenticateCurrentUser } from '../services/auth';

/** Cognito group name for no-access users: add this group in AWS Cognito. When assigned, user sees "No access" page only. */
export const NO_ACCESS_GROUP_KEY = 'no-access';

const treeData = [
  {
    title: 'No Access to Platform',
    key: NO_ACCESS_GROUP_KEY,
  },
  {
    title: 'Super Admin',
    key: 'admin',
  },
  {
    title: 'Admin',
    key: 'super-admin',
  },
  {
    title: 'Dashboard',
    key: 'dashboard',
    children: [
      {
        title: 'Normal User',
        key: 'web-page-without-create-project',
      },
      {
        title: 'Normal User With Create Project',
        key: 'web-page',
      },
    ],
  },
  {
    title: 'Analysis',
    key: 'analysis',
  },
  {
    title: 'Ask Evans',
    key: 'AskEvans',
    children: [
      {
        title: 'Admin',
        key: 'askevans-training-data',
      },
      {
        title: 'Normal User',
        key: 'askevans-normal-user',
      },
    ],
  },
  {
    title: 'Impact Dashboard',
    key: 'Impact-Dashboard',
    children: [
      {
        title: 'Admin',
        key: 'impact-dashboard',
      },

      {
        title: 'Senior Leadership Team',
        key: 'impact-dashboard-slt',
      },
      {
        title: 'Normal User',
        key: 'impact-dashboard-normal-user',
      },
    ],
  },
  {
    title: 'Technical',
    key: 'technical',
    children: [
      {
        title: 'Heat Profile',
        key: 'heat-profile',
      },
      {
        title: 'Coating Record Database',
        key: 'coating-record-db',
      },
      {
        title: 'DCAL Generator',
        key: 'dcal-generators',
        children: [
          {
            title: 'Admin',
            key: 'dcal-generator-master',
          },
          {
            title: 'Normal User',
            key: 'dcal-generator',
          },
        ],
      },
    ],
  },
  {
    title: 'Calibration & Control',
    key: 'Calibration-Control',
    children: [
      {
        title: 'Calibration',
        key: 'calibration-normal-user',
      },
    ],
  },
  {
    title: 'Lesson Learned',
    key: 'lesson-learned',
    children: [
      {
        title: 'Admin',
        key: 'LessonLearnedAdmin',
      },
      {
        title: 'Approver',
        key: 'LessonLearnedApprover',
      },
      {
        title: 'Normal User',
        key: 'LessonLearnedNormalUser',
      },
    ],
  },
  {
    title: 'Downtime Tracker',
    key: 'downtime-tracker',
    children: [
      {
        title: 'Admin',
        key: 'downtime-tracker-admin',
      },
      {
        title: 'Normal User',
        key: 'downtime-tracker-normal-user',
      },
      {
        title: 'Viewer',
        key: 'downtime-tracker-viewer',
      },
    ],
  },
];

const AddUserModal = (props) => {
  const {
    userModalVisible,
    setUserModalVisible,
    onSave,
    userForm,
    setUserModalLoading,
    createUserLoader,
    setCreateUserLoader,
    setIsEdit,
    isEdit,
    userName,
    setUserName,
    OnRemoveuserFromGroup,
    OnAdduserToGroup,
    setUserGroup,
    userGroup,
  } = props;
  const [isFormValid, setIsFormValid] = useState(false);
  const [disabledKeys, setDisabledKeys] = useState([]);
  const [processedTreeData, setProcessedTreeData] = useState(treeData);
  const [sendWelcomeEmail, setSendWelcomeEmail] = useState(true);
  const [isNoAccessSelected, setIsNoAccessSelected] = useState(false);

  // Initialize processed tree data on component mount
  useEffect(() => {
    if (userGroup && userGroup.length > 0) {
      processTreeData(userGroup);
    }
  }, []);

  const handleCancel = () => {
    setIsEdit(false);
    setUserModalVisible(false);
    setUserGroup([]);
    setDisabledKeys([]);
    setProcessedTreeData(treeData);
    setSendWelcomeEmail(true);
    setIsNoAccessSelected(false);
    userForm.resetFields();
  };

  // Collect all keys from tree (for no-access: disable all others)
  const getAllTreeKeys = (nodes) => {
    let keys = [];
    nodes.forEach((node) => {
      keys.push(node.key);
      if (node.children && node.children.length) keys = keys.concat(getAllTreeKeys(node.children));
    });
    return keys;
  };

  // Function to process tree data and update disabled keys
  const processTreeData = (selectedKeys) => {
    const rawKeys = Array.isArray(selectedKeys)
      ? selectedKeys
      : (selectedKeys?.checked || selectedKeys?.halfChecked || []);
    const keys = Array.isArray(rawKeys) ? [...rawKeys] : [];

    const newDisabledKeys = [];
    const newProcessedTreeData = JSON.parse(JSON.stringify(treeData));

    // No ACCESS: only this option selected; disable welcome email and all other access checkboxes
    if (keys.includes(NO_ACCESS_GROUP_KEY)) {
      const allKeys = getAllTreeKeys(treeData);
      const others = allKeys.filter((k) => k !== NO_ACCESS_GROUP_KEY);
      newDisabledKeys.push(...others);
      setSendWelcomeEmail(false);
      setIsNoAccessSelected(true);
      const disableAllExceptNoAccess = (nodes) => {
        nodes.forEach((node) => {
          node.disabled = node.key !== NO_ACCESS_GROUP_KEY;
          if (node.children) disableAllExceptNoAccess(node.children);
        });
      };
      disableAllExceptNoAccess(newProcessedTreeData);
      setDisabledKeys(newDisabledKeys);
      setProcessedTreeData(newProcessedTreeData);
      return [NO_ACCESS_GROUP_KEY];
    }

    setIsNoAccessSelected(false);

    // Define parent-child relationships for automatic selection
    // const parentChildMap = {
    //   'AskEvans': {
    //     normalUserKey: 'askevans-normal-user',
    //     adminKey: 'askevans-training-data'
    //   },
    //   'dcal-generators': {
    //     normalUserKey: 'dcal-generator',
    //     adminKey: 'dcal-generator-master'
    //   }
    // };

    // // Process each parent node
    // Object.keys(parentChildMap).forEach(parentKey => {
    //   const { normalUserKey, adminKey } = parentChildMap[parentKey];

    //   if (selectedKeys.includes(parentKey)) {
    //     // If parent is selected, automatically select normal user and disable admin
    //     if (!selectedKeys.includes(normalUserKey)) {
    //       selectedKeys.push(normalUserKey);
    //     }
    //     newDisabledKeys.push(adminKey);

    //     // Update the tree data to show admin as disabled
    //     const updateNodeDisabled = (nodes) => {
    //       nodes.forEach(node => {
    //         if (node.key === adminKey) {
    //           node.disabled = true;
    //         } else if (node.children) {
    //           updateNodeDisabled(node.children);
    //         }
    //       });
    //     };
    //     updateNodeDisabled(newProcessedTreeData);
    //   } else {
    //     // If parent is not selected, remove normal user from selection and enable admin
    //     const normalUserIndex = selectedKeys.indexOf(normalUserKey);
    //     if (normalUserIndex > -1) {
    //       selectedKeys.splice(normalUserIndex, 1);
    //     }

    //     // Remove admin from disabled keys
    //     const adminIndex = newDisabledKeys.indexOf(adminKey);
    //     if (adminIndex > -1) {
    //       newDisabledKeys.splice(adminIndex, 1);
    //     }

    //     // Update the tree data to show admin as enabled
    //     const updateNodeEnabled = (nodes) => {
    //       nodes.forEach(node => {
    //         if (node.key === adminKey) {
    //           node.disabled = false;
    //         } else if (node.children) {
    //           updateNodeEnabled(node.children);
    //         }
    //       });
    //     };
    //     updateNodeEnabled(newProcessedTreeData);
    //   }
    // });

    // Special logic for Impact Dashboard
    if (keys.includes('impact-dashboard')) {
      // If admin is selected, auto-select both senior leadership team and normal user, and disable them
      if (!keys.includes('impact-dashboard-slt')) {
        keys.push('impact-dashboard-slt');
      }
      if (!keys.includes('impact-dashboard-normal-user')) {
        keys.push('impact-dashboard-normal-user');
      }
      newDisabledKeys.push('impact-dashboard-slt', 'impact-dashboard-normal-user');

      // Update the tree data to show both as disabled
      const updateNodesDisabled = (nodes) => {
        nodes.forEach((node) => {
          if (node.key === 'impact-dashboard-slt' || node.key === 'impact-dashboard-normal-user') {
            node.disabled = true;
          } else if (node.children) {
            updateNodesDisabled(node.children);
          }
        });
      };
      updateNodesDisabled(newProcessedTreeData);
    } else if (keys.includes('impact-dashboard-slt')) {
      // If senior leadership team is selected, auto-select normal user and disable it
      if (!keys.includes('impact-dashboard-normal-user')) {
        keys.push('impact-dashboard-normal-user');
      }
      newDisabledKeys.push('impact-dashboard-normal-user');

      // Update the tree data to show normal user as disabled
      const updateNormalUserDisabled = (nodes) => {
        nodes.forEach((node) => {
          if (node.key === 'impact-dashboard-normal-user') {
            node.disabled = true;
          } else if (node.children) {
            updateNormalUserDisabled(node.children);
          }
        });
      };
      updateNormalUserDisabled(newProcessedTreeData);
    } else {
      // If neither admin nor senior leadership team is selected, enable both
      const seniorLeadershipIndex = newDisabledKeys.indexOf('impact-dashboard-slt');
      if (seniorLeadershipIndex > -1) {
        newDisabledKeys.splice(seniorLeadershipIndex, 1);
      }
      const normalUserIndex = newDisabledKeys.indexOf('impact-dashboard-normal-user');
      if (normalUserIndex > -1) {
        newDisabledKeys.splice(normalUserIndex, 1);
      }

      // Update the tree data to show both as enabled
      const updateNodesEnabled = (nodes) => {
        nodes.forEach((node) => {
          if (node.key === 'impact-dashboard-slt' || node.key === 'impact-dashboard-normal-user') {
            node.disabled = false;
          } else if (node.children) {
            updateNodesEnabled(node.children);
          }
        });
      };
      updateNodesEnabled(newProcessedTreeData);
    }

    setDisabledKeys(newDisabledKeys);
    setProcessedTreeData(newProcessedTreeData);
    return keys;
  };
  const createUser = async (data) => {
    try {
      setCreateUserLoader(true);
      const accessToRemove = ['dashboard', 'technical', 'AdminSection', 'Calibration', 'AskEvans'];
      // Function to extract only leaf nodes (groups without children)
      const extractLeafKeys = (nodes) => {
        let keys = [];
        nodes.forEach((node) => {
          if (!node.children || node.children.length === 0) {
            keys.push(node.key);
          } else {
            keys = keys.concat(extractLeafKeys(node.children));
          }
        });
        return keys;
      };

      // Get all leaf (actual group) names from treeData
      const allLeafGroupKeys = extractLeafKeys(treeData);

      // Filter only leaf nodes from the selected access list
      const validAccess = (data.access || []).filter(
        (item) => allLeafGroupKeys.includes(item) && !accessToRemove.includes(item)
      );

      // Get the current logged-in user's email
      const currentUser = await authenticateCurrentUser();
      const creatorEmail =
        currentUser?.attributes?.email || currentUser?.username || 'Administrator';

      // No password needed - backend will auto-generate
      const postData = {
        userFirstName: data.firstName,
        userLastName: data?.lastName,
        email: data.email.toLowerCase().trim(),
        groups: validAccess,
        sendInviteEmail: sendWelcomeEmail, // Configurable via checkbox
        creatorEmail, // Include the current user's email as the creator
      };

      const result = await onSave(postData, sendWelcomeEmail);

      // If user creation is successful, check if password is returned (when invite email is not sent)
      if (result?.status === 200) {
        const email = data.email.toLowerCase().trim();
        // Password is at result.data.password based on response structure
        const password = result?.data?.password;

        if (password) {
          // Automatically copy credentials to clipboard
          const credentialsText = `Email: ${email}\nPassword: ${password}`;
          navigator.clipboard
            .writeText(credentialsText)
            .then(() => {
              notification.success({
                message: 'User created successfully!',
                description: 'Credentials have been copied to clipboard.',
                duration: 3,
              });
            })
            .catch(() => {
              notification.success({
                message: 'User created successfully!',
                description: `${email} has been added.`,
                duration: 3,
              });
              notification.error({
                message: 'Failed to copy credentials to clipboard',
                duration: 2,
              });
            });
        }
      }
    } catch (err) {
      console.error('Error creating user:', err);
      notification.warning({
        message: typeof err === 'string' ? err : err?.message || 'Something went wrong.',
      });
      setCreateUserLoader(false);
      setUserModalLoading(false);
    }
  };

  const validateAndCreateUser = async () => {
    try {
      const data = await userForm.validateFields();

      if (!data.email || data.email === '') {
        notification.warning({
          message: 'Enter email ID to proceed!',
        });
        return;
      }

      if (!data.access || data.access.length === 0) {
        notification.warning({
          message: 'Please select at least one access role!',
        });
        return;
      }

      setUserModalLoading(true);
      await createUser(data);
    } catch (err) {
      console.error('Validation error:', err);
    }
  };

  // const updateUserAccess = async () => {
  //   try {
  //     const data = await userForm.validateFields();
  //     setCreateUserLoader(true);
  //     setUserModalLoading(true);

  //     const isWebPageSelected = data.access.includes('web-page');
  //     const isAdminSelected = data.access.includes('admin');
  //     const isAnalysisSelected = data.access.includes('analysis');
  //     const isHeatProfile = data.access.includes('heat-profile');
  //     const isCoatingDb = data.access.includes('coating-record-db');
  //     const isDcalGenerator = data.access.includes('dcal-generator');
  //     const isDcalGeneratorMaster = data.access.includes('dcal-generator-master');

  //     if (isWebPageSelected && !userGroup.includes('web-page')) {
  //       await updateUserGroup('web-page');
  //     } else if (!isWebPageSelected && userGroup.includes('web-page')) {
  //       await removeUserFromGroup('web-page');
  //     }

  //     if (isAdminSelected && !userGroup.includes('admin')) {
  //       await updateUserGroup('admin');
  //     } else if (!isAdminSelected && userGroup.includes('admin')) {
  //       await removeUserFromGroup('admin');
  //     }

  //     if (isAnalysisSelected && !userGroup.includes('analysis')) {
  //       await updateUserGroup('analysis');
  //     } else if (!isAnalysisSelected && userGroup.includes('analysis')) {
  //       await removeUserFromGroup('analysis');
  //     }

  //     if (isHeatProfile && !userGroup.includes('heat-profile')) {
  //       await updateUserGroup('heat-profile');
  //     } else if (!isHeatProfile && userGroup.includes('heat-profile')) {
  //       await removeUserFromGroup('heat-profile');
  //     }

  //     if (isCoatingDb && !userGroup.includes('coating-record-db')) {
  //       await updateUserGroup('coating-record-db');
  //     } else if (!isCoatingDb && userGroup.includes('coating-record-db')) {
  //       await removeUserFromGroup('coating-record-db');
  //     }
  //     if (isDcalGenerator && !userGroup.includes('dcal-generator')) {
  //       await updateUserGroup('dcal-generator');
  //     } else if (!isDcalGenerator && userGroup.includes('dcal-generator')) {
  //       await removeUserFromGroup('dcal-generator');
  //     }

  //     if (isDcalGeneratorMaster && !userGroup.includes('dcal-generator-master')) {
  //       await updateUserGroup('dcal-generator-master');
  //     } else if (!isDcalGeneratorMaster && userGroup.includes('dcal-generator-master')) {
  //       await removeUserFromGroup('dcal-generator-master');
  //     }
  //     setUserName('');
  //     setUserGroup([]);
  //   } catch (error) {
  //     console.error('Error updating user access:', error);
  //   } finally {
  //     setCreateUserLoader(false);
  //     setUserModalLoading(false);
  //   }
  // };

  const updateUserAccess = async () => {
    try {
      const data = await userForm.validateFields();
      setCreateUserLoader(true);
      setUserModalLoading(true);

      // Extract selected keys from the form
      const selectedKeys = data.access || [];

      // Function to extract only leaf nodes (groups without children)
      const extractLeafKeys = (nodes) => {
        let keys = [];
        nodes.forEach((node) => {
          if (!node.children || node.children.length === 0) {
            keys.push(node.key);
          } else {
            keys = keys.concat(extractLeafKeys(node.children));
          }
        });
        return keys;
      };

      // Get all leaf (actual group) names from treeData
      const allLeafGroupKeys = extractLeafKeys(treeData);

      const addGroupsList = [];
      const removeGroupsList = [];

      // Loop through all group keys and update or remove them accordingly
      for (const group of allLeafGroupKeys) {
        if (selectedKeys.includes(group)) {
          if (!userGroup.includes(group)) {
            addGroupsList.push({ group, userName });
          }
        } else {
          if (userGroup.includes(group)) {
            removeGroupsList.push({ group, userName });
          }
        }
      }
      // console.log("Groups to Add:", userGroup);
      // console.log("Groups to Add:", addGroupsList);
      // console.log("Groups to Remove:", removeGroupsList);

      //Call add/remove functions only if needed
      if (addGroupsList.length > 0) await OnAdduserToGroup(addGroupsList);
      if (removeGroupsList.length > 0) await OnRemoveuserFromGroup(removeGroupsList);

      // Reset user info
      setUserName('');
      setUserGroup([]);
    } catch (error) {
      console.error('Error updating user access:', error);
    } finally {
      setCreateUserLoader(false);
      setUserModalLoading(false);
    }
  };
  const updateUserGroup = async (group) => {
    await OnAdduserToGroup({ group, userName });
  };

  const removeUserFromGroup = async (group) => {
    await OnRemoveuserFromGroup({ group, userName });
  };

  const handleFormValuesChange = (_, allValues) => {
    const { firstName, email, access } = allValues;
    const isFormValid = firstName && email && access && access.length > 0;
    setIsFormValid(isFormValid);
  };

  const handleTreeSelect = (selectedKeys) => {
    // Process the selected keys to implement automatic selection logic
    const processedKeys = processTreeData(selectedKeys);
    userForm.setFieldsValue({ access: processedKeys });
  };

  return (
    <>
      <Modal
        width={750}
        className="quality-modal"
        title={isEdit ? 'Edit User Access' : 'Create User'}
        centered
        visible={userModalVisible}
        footer={
          isEdit
            ? [
                <Button key="submit1" type="default" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button
                  key="submit2"
                  loading={createUserLoader}
                  type="primary"
                  disabled={createUserLoader}
                  onClick={() => updateUserAccess()}
                >
                  Update
                </Button>,
              ]
            : [
                <Button key="submit3" type="default" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button
                  key="submit4"
                  loading={createUserLoader}
                  type="primary"
                  disabled={createUserLoader}
                  onClick={() => validateAndCreateUser()}
                >
                  {sendWelcomeEmail ? 'Create User' : 'Create User and Copy Credentials'}
                </Button>,
              ]
        }
      >
        <div className="signup-form">
          <Form
            id="create-user-form"
            name="basic"
            layout="vertical"
            autoComplete="off"
            form={userForm}
            initialValues={{
              remember: true,
            }}
            onValuesChange={handleFormValuesChange}
            onFinish=""
          >
            <Row gutter={16}>
              <Col lg={12}>
                <Form.Item
                  label="First Name"
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your First Name.',
                    },
                  ]}
                  normalize={(value) => utility.trimSpacesInValues(value)}
                >
                  <Input
                    size="large"
                    placeholder="Enter First Name"
                    maxLength={25}
                    disabled={isEdit}
                  />
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item
                  label="Last Name"
                  name="lastName"
                  rules={[
                    {
                      required: false,
                      message: 'Please enter your Last Name.',
                    },
                  ]}
                  normalize={(value) => utility.trimSpacesInValues(value)}
                >
                  <Input
                    size="large"
                    placeholder="Enter Last Name"
                    maxLength={25}
                    disabled={isEdit}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Please enter your Email.',
                },
                {
                  pattern: true ? constants.EMAIL_PATTERN : undefined,
                  message: 'Provide a valid Email.',
                },
              ]}
              normalize={(value) => utility.trimSpacesInValues(value)}
            >
              <Input size="large" placeholder="Enter Email" disabled={isEdit} />
            </Form.Item>

            {/* Send welcome email checkbox for new users — disabled when "No ACCESS" is selected */}
            {!isEdit && (
              <Form.Item style={{ marginBottom: '16px' }}>
                <Checkbox
                  checked={sendWelcomeEmail}
                  disabled={isNoAccessSelected}
                  onChange={(e) => !isNoAccessSelected && setSendWelcomeEmail(e.target.checked)}
                >
                  <span style={{ fontWeight: 500 }}>
                    Send welcome email with link to set password
                  </span>
                </Checkbox>
                {sendWelcomeEmail && !isNoAccessSelected && (
                  <div
                    style={{
                      marginLeft: '24px',
                      marginTop: '4px',
                      color: '#666',
                      fontSize: '12px',
                    }}
                  >
                    The user will receive an invitation email with a secure link to set their own
                    password.
                  </div>
                )}
                {isNoAccessSelected && (
                  <div
                    style={{
                      marginLeft: '24px',
                      marginTop: '4px',
                      color: '#888',
                      fontSize: '12px',
                    }}
                  >
                    No ACCESS users do not receive welcome email; other access options are disabled.
                  </div>
                )}
              </Form.Item>
            )}

            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              className="mb-0"
              label="Access"
              name="access"
              rules={[
                {
                  required: true,
                  message: 'At least one Access is required.',
                },
              ]}
            >
              <Tree
                className="user-access-tree"
                checkable
                treeData={processedTreeData}
                onCheck={handleTreeSelect}
                defaultCheckedKeys={userGroup}
                disabledKeys={disabledKeys}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default AddUserModal;
